// extracted by mini-css-extract-plugin
export default {"centerIcon":"styles_centerIcon__jeQ8S"};